import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './components/Authentication/login/login.component';

import { ProfileComponent } from './components/core/profile/profile.component';
import { ResigteringComponent } from './components/Authentication/resigtering/resigtering.component';
import { VerificationCodeComponent } from './components/Authentication/verification-code/verification-code.component';
import { authGuard } from './guards/auth.guard';
import { AccessGuard } from './guards/access.guard';

import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { ForgetPasswordComponent } from './components/Authentication/forget-password/forget-password.component';
import { ChangePasswordComponent } from './components/Authentication/change-password/change-password.component';
import { AllusersComponent } from './components/core/allusers/allusers.component';

import { AllusersmobileComponent } from './components/core/allusersmobile/allusersmobile.component';
import { MyclientspageComponent } from './components/core/clients manager/myclientspage/myclientspage.component';

import { AllemployeesComponent } from './components/core/Employees Manager/allemployees/allemployees.component';
import { AddemployeeComponent } from './components/core/Employees Manager/addemployee/addemployee.component';
import { EmployeeComponent } from './components/core/Employees Manager/employee/employee.component';
import { EmployeepagemobileComponent } from './components/core/Employees Manager/employeepagemobile/employeepagemobile.component';
import { DailyexpensespageComponent } from './components/core/financial manager/dailyexpensespage/dailyexpensespage.component';

import { EmployeefingerprintComponent } from './components/core/Employees Manager/employeefingerprint/employeefingerprint.component';
import { CreateclientComponent } from './components/core/clients manager/createclient/createclient.component';
import { MyComplexRequestComponent } from './components/core/clients manager/my-complex-request/my-complex-request.component';

import { CreateComplexRequestComponent } from './components/core/clients manager/create-complex-request/create-complex-request.component';
import { AllvisaclientsComponent } from './components/core/visa clients/allvisaclients/allvisaclients.component';
import { CreatevisaclientComponent } from './components/core/visa clients/createvisaclient/createvisaclient.component';
import { AllflyclientesComponent } from './components/core/fly/allflyclientes/allflyclientes.component';
import { CreateflyclientComponent } from './components/core/fly/createflyclient/createflyclient.component';
import { AllpricelistComponent } from './components/core/price list/allpricelist/allpricelist.component';
import { CreatepriceComponent } from './components/core/price list/createprice/createprice.component';
import { AllcompaniesComponent } from './components/core/companies/allcompanies/allcompanies.component';
import { CreatecompanyComponent } from './components/core/companies/createcompany/createcompany.component';
import { CreatedoctorComponent } from './components/core/doctors/createdoctor/createdoctor.component';
import { AlldoctorsComponent } from './components/core/doctors/alldoctors/alldoctors.component';
import { AlldataflowclientComponent } from './components/core/dataflow/alldataflowclient/alldataflowclient.component';
import { CreatedataflowclientComponent } from './components/core/dataflow/createdataflowclient/createdataflowclient.component';
import { AlljobsComponent } from './components/core/alljobs/alljobs/alljobs.component';
import { CreatejobComponent } from './components/core/alljobs/createjob/createjob.component';
import { ContactUsComponent } from './components/core/contact-us/contact-us.component';
import { NodataComponent } from './shared/nodata/nodata.component';
import { AllappsComponent } from './allapps/allapps.component';
import { AnalyticsComponent } from './analytics/analytics.component';
import { DentistformComponent } from './components/core/forms/dentistform/dentistform.component';
import { AppsComponent } from './components/core/apps/apps.component';
import { DentistComponent } from './components/core/dentist/dentist.component';
import { AlldentistComponent } from './components/core/doctors/alldentist/alldentist.component';
import { NotificationsComponent } from './components/core/websitecontentmanager/notifications/notifications.component';
import { CreateJobComponent } from './components/core/ahmedelshahatjobs/jobs/create-job/create-job.component';
import { AddSkillsComponent } from './components/core/ahmedelshahatjobs/skills/add-skills/add-skills.component';
import { JobListComponent } from './components/core/ahmedelshahatjobs/jobs/job-list/job-list.component';
import { CountryandcityComponent } from './components/core/ahmedelshahatjobs/countryandcity/countryandcity/countryandcity.component';
import { ApplyComponent } from './components/core/ahmedelshahatjobs/apply/apply.component';
import { ReviewsComponent } from './components/core/website/reviews/reviews.component';
import { AllblogsComponent } from './components/core/website/allblogs/allblogs.component';
import { CreateblogComponent } from './components/core/website/createblog/createblog.component';
import { AllchatsComponent } from './components/core/website/allchats/allchats.component';
import { ConversationComponent } from './components/core/website/conversation/conversation.component';
import { QuickrepliesmanagementComponent } from './components/core/website/quickrepliesmanagement/quickrepliesmanagement.component';


const routes: Routes = [
  { path: 'apps', component: AppsComponent },
  { path: 'allchats', component: AllchatsComponent, canActivate: [authGuard] },

{
  path: 'conversation/:id',
  component: ConversationComponent,
  canActivate: [authGuard],
},

{
  path: 'quick-replies-management',
  component: QuickrepliesmanagementComponent,
  canActivate: [authGuard],
},
  { path: 'Slider', component: NotificationsComponent, canActivate: [authGuard] },
  { path: 'create-job', component: CreateJobComponent, canActivate: [authGuard] },
  {
  path: 'create-job/:id',
  component: CreateJobComponent, canActivate: [authGuard]
},
    { path: 'allblogs', component: AllblogsComponent, canActivate: [authGuard] },
        { path: 'createblog', component: CreateblogComponent, canActivate: [authGuard] },

        { path: 'add-skill', component: AddSkillsComponent, canActivate: [authGuard] },
        { path: 'alljobs', component: JobListComponent, canActivate: [authGuard] },
        { path: 'apply', component: ApplyComponent, canActivate: [authGuard] },
          { path: 'add-country', component: CountryandcityComponent, canActivate: [authGuard] },
            { path: 'reviews', component: ReviewsComponent, canActivate: [authGuard] },
  { path: 'Login', component: LoginComponent },
  { path: 'dentistform', component: DentistformComponent },
  { path: 'allapps', component: AllappsComponent, canActivate: [authGuard] },
  { path: 'analytics', component: AnalyticsComponent, canActivate: [authGuard] },
  { path: 'allusers', component: AllusersComponent, canActivate: [authGuard, AccessGuard], data: { adminOnly: true } },
  { path: 'allusers.mobile', component: AllusersmobileComponent, canActivate: [authGuard, AccessGuard], data: { adminOnly: true } },
  { path: 'Profile', component: ProfileComponent, canActivate: [authGuard] },
  { path: 'Resigter', component: ResigteringComponent, canActivate: [authGuard] },
  { path: 'verificationCode', component: VerificationCodeComponent },
  { path: 'forget-password', component: ForgetPasswordComponent },
  { path: 'change-password', component: ChangePasswordComponent, canActivate: [authGuard] },
  { path: 'fingerprint', component: EmployeefingerprintComponent, canActivate: [authGuard] },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'no-data', component: NodataComponent, canActivate: [authGuard] },

  { path: 'myclients', component: MyclientspageComponent, canActivate: [authGuard, AccessGuard], data: { accessPage: "2" } },
  { path: 'createclient', component: CreateclientComponent, canActivate: [authGuard, AccessGuard], data: { accessPage: "2" } },

  { path: 'employeepage.mobile', component: EmployeepagemobileComponent, canActivate: [authGuard, AccessGuard], data: { adminOnly: true } },
  { path: 'addemployee', component: AddemployeeComponent, canActivate: [authGuard, AccessGuard], data: { adminOnly: true } },
  { path: 'allemployees', component: AllemployeesComponent, canActivate: [authGuard, AccessGuard], data: { adminOnly: true } },
  { path: 'employee', component: EmployeeComponent, canActivate: [authGuard, AccessGuard], data: { adminOnly: true } },

  { path: 'dailyexpenses', component: DailyexpensespageComponent, canActivate: [authGuard, AccessGuard], data: { accessPage: "1", deniedTypes: ["6"] } },



  { path: 'complex', component: MyComplexRequestComponent, canActivate: [authGuard, AccessGuard], data: { accessPage: "3" } },
  { path: 'createcomplex', component: CreateComplexRequestComponent, canActivate: [authGuard, AccessGuard], data: { accessPage: "3" } },

  { path: 'flyclients', component: AllflyclientesComponent, canActivate: [authGuard, AccessGuard], data: { accessPage: "4" } },
  { path: 'createflyclient', component: CreateflyclientComponent, canActivate: [authGuard, AccessGuard], data: { accessPage: "4" } },

  { path: 'pricelist', component: AllpricelistComponent, canActivate: [authGuard, AccessGuard], data: { accessPage: "5" } },
  { path: 'createpricelist', component: CreatepriceComponent, canActivate: [authGuard, AccessGuard], data: { accessPage: "5" } },

  { path: 'companies', component: AllcompaniesComponent, canActivate: [authGuard, AccessGuard], data: { accessPage: "8" } },
  { path: 'createcompany', component: CreatecompanyComponent, canActivate: [authGuard, AccessGuard], data: { accessPage: "8" } },
  { path: 'dentist/:id', component: DentistComponent },
  { path: 'alldentist', component: AlldentistComponent, canActivate: [authGuard, AccessGuard], data: { accessPage: "7" } },
  { path: 'doctors', component: AlldoctorsComponent, canActivate: [authGuard, AccessGuard], data: { accessPage: "7" } },
  { path: 'createdoctor', component: CreatedoctorComponent, canActivate: [authGuard, AccessGuard], data: { accessPage: "7" } },

  { path: 'alljobz', component: AlljobsComponent, canActivate: [authGuard, AccessGuard], data: { accessPage: "6" } },
  { path: 'createjob', component: CreatejobComponent, canActivate: [authGuard, AccessGuard], data: { accessPage: "6" } },

  { path: 'dataflow', component: AlldataflowclientComponent, canActivate: [authGuard, AccessGuard], data: { accessPage: "5" } },
  { path: 'createdataflow', component: CreatedataflowclientComponent, canActivate: [authGuard, AccessGuard], data: { accessPage: "5" } },


  { path: '', redirectTo: 'Login', pathMatch: 'full' },
  { path: '**', redirectTo: 'Login', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
